<template>
  <v-row>
    <v-col cols="12">
      <b class="custom-text">Declaração PEP (Pessoa Exposta Publicamente)</b>
      <v-tooltip top max-width="380">
        <template v-slot:activator="{ on }">
          <v-chip v-on="on" color="white">
            <img v-on="on" src="../assets/imgs/interrogacao.svg" alt="Interrogação Tooltip">
          </v-chip>
        </template>
        <span>
          Pessoa que exerce ou exerceu funções públicas
          relevantes, como cargos políticos, judiciais, militares
          ou altos executivos de empresas públicas.
        </span
        >
      </v-tooltip>
      <v-radio-group v-model="model.indicadorPEP" row :data-message="message" :data-invalid=invalid :rules="[rule]">
        <v-radio label="DECLARA que é pessoa exposta publicamente" :value="1"></v-radio>
        <v-radio label="DECLARA que não é pessoa exposta publicamente." :value="2"></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    value: null,
  },
  data () {
    return {
      invalid: false,
      message: 'Declaração PEP é obrigatório'
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    rule (value) {
      if (!value) {
        this.invalid = true
        return this.message
      } else {
        this.invalid = false
        return true
      }
    }
  },
}
</script>
